import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.leaveEmployee ? _vm.leaveEmployee.email : '')?_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VAvatar,_vm._g(_vm._b({attrs:{"color":"blue lighten-4","size":"40"}},'v-avatar',attrs,false),on),[_vm._v(" "+_vm._s((_vm.leaveEmployee.email[0] + _vm.leaveEmployee.email[1]) .toString() .toUpperCase())+" ")])]}}],null,false,2999154596)},[_c('span',[_vm._v(_vm._s(_vm.leaveEmployee ? _vm.leaveEmployee.email : "N/A"))])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }